import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $deposits,
  $totalCountOfDeposits,
  depositsListMounted,
  getDeposits,
} from './model'
import { DepositRequest } from './types'

export const useDepositsList = () => {
  const onChangeDepositsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: DepositRequest) => {
    depositsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }
  const loading = useStore(getDeposits.pending)

  const deposits = useStore($deposits)
  const totalCountOfDeposits = useStore($totalCountOfDeposits)
  return { deposits, totalCountOfDeposits, loading, onChangeDepositsList }
}
